import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);

  // O endpoint de login não deve receber token antigo.
  if (req.url.includes('/api/auth/login')) {
    return next(
      req.clone({
        headers: req.headers.delete('Authorization'),
      }),
    );
  }

  if (req.url.includes('/api/auth/primeiro-acesso/solicitar')) {
    return next(
      req.clone({
        headers: req.headers.delete('Authorization'),
      }),
    );
  }

  if (req.url.includes('/api/auth/primeiro-acesso/concluir')) {
    return next(
      req.clone({
        headers: req.headers.delete('Authorization'),
      }),
    );
  }

  const token = auth.token;

  if (!token) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    }),
  );
};
